export default __webpack_public_path__ + "static/media/b4.4cdd367e.jpg";